import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { OrderLineItemsSummary } from './OrderLineItemsSummary.js';

const OrderLineItemsSummaryContainer = ({ order  })=>{
    const { getLabel , currency  } = useIntl();
    const labels = {
        summaryLabel: getLabel('cart.discount.summary'),
        subtotal: getLabel('cart.value.subTotal'),
        total: getLabel('cart.value.total'),
        totalDiscount: getLabel('cart.value.totalDiscount'),
        delivery: getLabel('cart.delivery'),
        freeDelivery: getLabel('cart.delivery.forFree'),
        paymentMethod: order.paymentMethod
    };
    const prices = {
        subtotal: order.subtotalAmount,
        totalDiscount: order.discountedAmount,
        delivery: order.shippingMethodPrice,
        total: order.totalPrice,
        paymentMethodPrice: order.paymentMethodPrice
    };
    return /*#__PURE__*/ React.createElement(OrderLineItemsSummary, {
        currency: currency,
        labels: labels,
        prices: prices
    });
};

export { OrderLineItemsSummaryContainer };
//# sourceMappingURL=OrderLineItemsSummaryContainer.js.map
